/**
 *
 * Data Attribution Workflow
 *
 * Class for tracking attribution from anonymous users to iterable prospects
 *
 * @return ITBL local storage object
 *
 */

const $     = require( 'jquery' );
const _model  = require( './_model' );
const _LStorage = require( './_LStorage' );

var DataAttribution = function () {

  //set the crucial variables
  this.itblObj = 'iterable';
  this.emptyItblObj = {
    webHistory: [],
    webHistoryPayload: 0,
    browserToken: false,
    cookiesConsent: false,

  };

  //LETS GO
  this.init();
};


DataAttribution.prototype.init = function () {

  //check + save the iterable localstorage obj
  this.setup__setUpLocalStorage();

  //reset
  this.debug__resetObj();
  this.debug__setCookies();

};

DataAttribution.prototype.setup__setUpLocalStorage = function () {

  var that = this;
  //parse UTM paramaters
  const URLString = (window.location.href).toLowerCase();
  const url = new URL(URLString);
  let todayDate = new Date().toISOString().slice(0, 10);

  //create session data for today
  this.sessionData = Object.assign(
    {},
    {
      date: todayDate
    },
    _model.model__getUTMs()
  );

  //setup the iterable Object
  if (_LStorage.hasData(this.itblObj)) {
    //get the localstorage obj for work

    //get the localstorage obj
    let iterableLocalStorage = _LStorage.get(this.itblObj);

    //merge the objects, adding properties if they don't exist
    //if the iterable object is missing a base property, then this function will add the property to the localstorage object
    Object.keys(this.emptyItblObj)
      .filter(key => {
        //filter the keys and return keys that don't exist in the localstorage object
        return !iterableLocalStorage.hasOwnProperty(key);
      })
      .forEach(key => {
        //add the missing keys from the empty obj to the localstorage obj
        iterableLocalStorage[key] = this.emptyItblObj[key]
      });

    //set the localstorage obj back to iterable
    _LStorage.set(this.itblObj, iterableLocalStorage);

  } else {
    //we don't have data. so let's create an empty obj
    _LStorage.set(this.itblObj, this.emptyItblObj);

  }

  //check for cookies and assign values if cookies exist
  if (Cookies.get('formWorkEmail')) {

    //set the email attribute - this is SO IMPORTANT!!!
    const emailCookieVal = Cookies.get('formWorkEmail');

    _LStorage.extend(this.itblObj, {email: emailCookieVal});

    const oldCookies = {
      firstName: 'formFirstName',
      lastName: 'formLastName',
      email: 'formWorkEmail',
      company: 'formCompanyName'
    };

    //set local storage values
    //delete the old cookies
    $.each(oldCookies, function (key, val) {

      Cookies.remove(val);
    });

  }

};


DataAttribution.prototype.router = function () {

  var that = this;
  var payload = {};

  //getting these variables here so they are the most up to date
  this.lsOBJ = _LStorage.get(this.itblObj);
  this.decryptedEmail = _LStorage.decrypt__get('iterable/encrypted/email');
  //this is a super important variable - this validates whether webhistory payload has been delivered
  this.checkWebHistoryPayload = (this.decryptedEmail && (typeof Object.keys(this.lsOBJ) !== 'undefined') && (this.lsOBJ['webHistoryPayload'] === 0));

  //if there a cookie email, and there is a localstorahe object that contains webhistory
  //then this means the user has filled out a for, and has anonymous tracking before form event
  if (this.lsOBJ.webHistoryPayload > 0) {

    return false;

  } else if (this.checkWebHistoryPayload) {


    //set important variables for the API call
    payload.email = this.decryptedEmail;


    //publish the webhistory one more time
    this.model__addToWebHistory();

    //set the variables here to overwrite the most recent UTM data
    payload.UTM_Source = this.sessionData.UTM_Source;
    payload.UTM_Campaign = this.sessionData.UTM_Campaign;
    payload.UTM_Medium = this.sessionData.UTM_Medium;
    payload.UTM_Term = this.sessionData.UTM_Term;
    payload.webHistory = this.lsOBJ.webHistory;
  } else if (this.lsOBJ.hasOwnProperty('webHistory')) {

    this.model__addToWebHistory();

  }
};

//this helper function is mainly used by other classes
// @param response is an API call from some where else, if succes, this function will turn off
//the web history tracking
DataAttribution.prototype.helper__hasWebHistoryPayload = function (response) {

  if (_model.empty(response)) {
    return;
  }

  if (_LStorage.decrypt__get('iterable/encrypted/email') && response.hasOwnProperty('successCount') && response.successCount > 0) {

    //sets the webpayload to success so that it stops recording
    _LStorage.extend(this.itblObj, {webHistoryPayload: response.successCount});

  }

};

//checks to see if there's no webhistory delivered, if there isn't, then we return the webhistory obj
DataAttribution.prototype.helper__addWebHistory = function () {

  //ok so be sure to get the most up to date web history
  const obj = _LStorage.get(this.itblObj);

  if ((typeof Object.keys(obj) !== 'undefined') && (obj['webHistoryPayload'] === 0) && !_model.empty(obj.webHistory)) {

    return {'webHistory': obj.webHistory};
  } else {
    return {};
  }

};

DataAttribution.prototype.event__triggerItblApiEvent = function (event) {

  //check to see if there's a value in the email obj
  if (_LStorage.getValFromStorage(this.itblObj, 'email')) {

    let ajaxObj = _LStorage.get(this.itblObj);

    //add additional values to ITBL onj
    ajaxObj.eventName = 'Loaded a Page';
  }

};

DataAttribution.prototype.model__addToWebHistory = function () {

  //save anonymous itbl object
  _LStorage.pushToArray(this.itblObj, 'webHistory', this.sessionData);

};


// watch for D-E-V
DataAttribution.prototype.debug__resetObj = function () {
  //if we are in debug mode, fire this function

  var map = {68: false, 69: false, 86: false};
  $(document).keydown(function (e) {
    if (e.keyCode in map) {
      map[e.keyCode] = true;
      if (map[68] && map[69] && map[86]) {

        // remove the itbl obj for dev testing purposes

        let deletedLS = [];

        //loop through each key in localstorage Obj
        for (var key in localStorage) {
          //check each key to see it contains 'iterable'
          if (key.includes('iterable')) {
            //collect items that were deleted and remove from localstorage
            deletedLS.push(key);
            _LStorage.remove(key);
          }
        }
      }
    }
  }).keyup(function (e) {
    if (e.keyCode in map) {
      map[e.keyCode] = false;
    }
  });


};

//watch for C-O-K
DataAttribution.prototype.debug__setCookies = function () {


  var map = {67: false, 79: false, 75: false};
  $(document).keydown(function (e) {
    if (e.keyCode in map) {
      map[e.keyCode] = true;
      if (map[67] && map[79] && map[75]) {
        // set cookies for testing purposes
        Cookies.set('formFirstName', 'Gabriel');
        Cookies.set('formLastName', 'Ortiz');
        Cookies.set('formWorkEmail', 'gabriel.ortiz@iterable.com');
        Cookies.set('formCompanyName', 'iterable');

      }
    }
  }).keyup(function (e) {
    if (e.keyCode in map) {
      map[e.keyCode] = false;
    }
  });


};

//function for sending the loaded a page event
DataAttribution.prototype.helper__handlePageLoaded = function () {

  console.log(this.sessionData);

};

//let's assign this to a variable so we can do stuff with it
var attribution = new DataAttribution();

module.exports = DataAttribution;

